// REACT
import React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// CUSTOM COMPONENTS
import { FluidSection } from 'components/FluidSection/index';
import { Content } from 'components/Content/index';
import { List } from 'components/List';
import { StretchCard } from 'components/StretchCard/index';
import { StretchVideo } from 'components/StretchVideo';
import { VideoModal } from 'components/VideoModal';
import { Calendar } from 'components/Calendar';
import { Button } from 'components/Button/index';

import Chat from '../Chat/ChatComponent';
import PhotoLog from 'components/PhotoLogs/PhotoLog';
import VideoDocuments from 'components/VideoDocumentSharing/VideoDocuments';

import ProBookingModule from 'components/Booking/ProBookingModule';
import ClientBookingModule from 'components/Booking/ClientBookingModule';

// UTILS
import { constants } from 'constants/index';
import { getInitialsString } from '../../utils/avatarUtils';
import { toArray } from 'utils/lodashUtils';

// VENDOR COMPONENTS
import FlatButton from 'material-ui/FlatButton';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import { Tabs, Tab } from 'material-ui/Tabs';
import StyledSwipeableViews from 'components/StyledSwipeableViews';
import Message from 'material-ui/svg-icons/communication/message';
import VideoCam from 'material-ui/svg-icons/av/videocam';
import PhotoCamera from 'material-ui/svg-icons/image/photo-camera';
import Archive from 'material-ui/svg-icons/content/archive';
import Badge from 'material-ui/Badge';
import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import TextButton from '../Button/TextButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';

// INTERACTION PANEL STYLED COMPONENTS
import ContextualBarSC from './ContextualBarSC';
import InteractionPanelOuterContainerSC from './InteractionPanelOuterContainerSC';
import InteractionWindowSC from './InteractionWindowSC';

import BackgroundGradient from '../DivStyleAdders/BackgroundGradient';
import InteractionModulesSC from './InteractionModulesSC';
// import { getInteractionWidth } from 'utils/layoutUtils';

import ScreenDimensionProvider from '../../../ScreenDimensionProvider';

class InteractionPanel extends React.Component {
    constructor() {
        super();
        this.state = {
            viewIndex: 0,
            tabsHeight: 73,
        };
    }

    componentDidMount() {
        const {
            providers,
            companies,
            services,
            userData,
            selectedClient,
            selectedService,
            shouldHideBookingTab,
            getServiceModules,
        } = this.props;
        this.initializeViewIndex(shouldHideBookingTab);
        this.props.getNotificationCounts({
            userId: userData && userData.uid,
            senderId:
                (selectedClient && selectedClient.uid) ||
                (selectedService && selectedService.provider),
            serviceId: selectedService && selectedService._id,
        });
        if (this.props.userData && this.props.userData.provider) {
            this.props.getMessageThread(
                this.props.userData,
                selectedService,
                () => {},
                'provider',
                selectedClient,
            );
        } else if (this.props.userData && !this.props.userData.provider) {
            this.props.getMessageThread(
                this.props.userData,
                selectedService,
                threadKey => {},
            );
        }
        getServiceModules(selectedService._id);
    }

    componentWillUpdate(nextProps, nextState) {
        const {
            providers,
            companies,
            services,
            userData,
            selectedClient,
            selectedService,
        } = nextProps;
        if (
            nextProps.selectedService &&
            this.props.selectedService &&
            this.props.selectedService._id !== nextProps.selectedService._id
        ) {
            // console.log('WE HAVE A NEW SERVICE');
            this.props.getNotificationCounts({
                userId: nextProps.userData && nextProps.userData.uid,
                senderId:
                    (nextProps.selectedClient &&
                        nextProps.selectedClient.uid) ||
                    (nextProps.selectedService &&
                        nextProps.selectedService.provider),
                serviceId:
                    nextProps.selectedService && nextProps.selectedService._id,
            });
            if (this.props.userData && this.props.userData.provider) {
                this.props.getMessageThread(
                    this.props.userData,
                    selectedService,
                    () => {},
                    'provider',
                    selectedClient,
                );
            } else if (this.props.userData && !this.props.userData.provider) {
                this.props.getMessageThread(
                    this.props.userData,
                    selectedService,
                    threadKey => {},
                );
            }
        }
        if (selectedService && selectedService._id) {
            this.getUnreadCount(selectedService);
        }
    }

    getUnreadCount = service => {
        // console.log('GETTING UNREAD COUNT FOR SERVICE:', service._id);
        // console.log('selectedClient@getUnreadCount', this.props.selectedClient);
        if (!this.state.gotCount && this.props.selectedClient) {
            // GET UNREADS FOR SERVICE PROVIDER // console.log('GETTING UNREAD NOTIFICATIONS FOR SERVICE PROVIDER');
            this.props.checkUnreadsForServiceConsumerPair(
                this.props.userId,
                this.props.selectedClient.uid,
                service._id,
            ); // Checks provider user's service for unread notifications
            this.setState({
                gotCount: true,
            });
        }
        if (!this.state.gotCount && !this.props.selectedClient) {
            // GET UNREADS FOR HEALTH CONSUMER // console.log('GETTING UNREAD NOTIFICATIONS FOR HEALTH CONSUMER');
            this.props.checkUnreadsForService(
                this.props.userId,
                null,
                service._id,
            ); // Checks provider user's service for unread notifications
            this.setState({
                gotCount: true,
            });
        }
    };

    initializeViewIndex = shouldHideBookingTab => {
        // console.log('Changing index to ', shouldHideBookingTab);
        if (shouldHideBookingTab) {
            this.setState(
                {
                    viewIndex: 1,
                },
                () => {
                    console.log(this.state.viewIndex);
                },
            );
        } else if (!shouldHideBookingTab) {
            this.setState(
                {
                    viewIndex: 0,
                },
                () => {
                    console.log(this.state.viewIndex);
                },
            );
        }
    };

    getAvatar = (userData, service, provider) => {
        if (userData && userData.provider) {
            return <Avatar src={service.coverPhotoURL} />;
        } else if (userData && !userData.provider) {
            return <Avatar src={provider.profilePhotoURL} />;
        }
    };

    getPrimaryText = (userData, service, selectedClient) => {
        // console.log('selectedClient', selectedClient)
        if (userData && userData.provider && selectedClient) {
            return `${selectedClient.firstName} ${selectedClient.lastName}`;
        } else if (userData && !userData.provider) {
            return service.name;
        }
    };

    getSecondaryText = (userData, service, provider) => {
        if (userData && userData.provider) {
            return service.name;
        } else if (userData && !userData.provider) {
            return `with ${provider.name &&
                provider.name.first} ${provider.name && provider.name.last}`;
        }
    };

    getBookingModule = (userData, provider, service, reduxLocation) => {
        if (userData && userData.provider) {
            return (
                <ProBookingModule
                    providerData={provider}
                    serviceSbmId={service.SBMId}
                    location={reduxLocation}
                    serviceId={service._id}
                />
            );
        } else if (userData && !userData.provider) {
            return (
                <ClientBookingModule
                    providerData={provider}
                    serviceSbmId={service.SBMId}
                    location={reduxLocation}
                    serviceId={service._id}
                />
            );
        }
    };
    getIconColor = viewIndexValue => {
        let iconColor = { color: 'gray' };
        if (viewIndexValue === this.state.viewIndex) {
            iconColor = { color: '#4AC4D1' };
        }
        return iconColor;
    };

    handleChangeViewIndex = index => {
        // console.log('Changing index to ', index);
        this.setState(
            {
                viewIndex: index,
            },
            () => {
                console.log(this.state.viewIndex);
            },
        );
    };

    handleIsModulePartOfService = (
        serviceModule,
        isDuringVideoSession,
        selectedServiceModules,
        serviceModuleTypes,
    ) => {
        // console.log('handleIsModulePartOfService-values', serviceModule, isDuringVideoSession, selectedServiceModules, serviceModuleTypes)
        const selectedServiceModulesArray = toArray(selectedServiceModules);
        let isModulePartOfService = null;
        let serviceModulesMatch = [];
        if (isDuringVideoSession) {
            isModulePartOfService = true;
        } else {
            switch (serviceModule) {
                case 'chat':
                    serviceModulesMatch = serviceModuleTypes.map(
                        platformServiceModule => {
                            if (
                                platformServiceModule._id ===
                                '-L5jP1bq2790Qaf4-frU'
                            ) {
                                let serviceModuleMatch = selectedServiceModulesArray.map(
                                    selectedServiceModule => {
                                        if (
                                            selectedServiceModule.type ===
                                            platformServiceModule._id
                                        ) {
                                            return true;
                                        }
                                    },
                                );
                                serviceModuleMatch = serviceModuleMatch.filter(
                                    filter => filter,
                                )[0];
                                return serviceModuleMatch;
                            } else {
                                return false;
                            }
                        },
                    );
                    break;
                case 'photoLog':
                    serviceModulesMatch = serviceModuleTypes.map(
                        platformServiceModule => {
                            if (
                                platformServiceModule._id ===
                                '-LBmlwPyzYFRA0SE48Rb'
                            ) {
                                let serviceModuleMatch = selectedServiceModulesArray.map(
                                    selectedServiceModule => {
                                        if (
                                            selectedServiceModule.type ===
                                            platformServiceModule._id
                                        ) {
                                            return true;
                                        }
                                    },
                                );
                                serviceModuleMatch = serviceModuleMatch.filter(
                                    filter => filter,
                                )[0];
                                return serviceModuleMatch;
                            } else {
                                return false;
                            }
                        },
                    );
            }
            if (serviceModulesMatch.includes(true)) {
                isModulePartOfService = true;
            } else {
                isModulePartOfService = false;
            }
        }
        return isModulePartOfService;
    };

    // TODO: THE PROVIDER, SERVICE, COMPANY SHOULD BE HANDLED IN THE INTERACTION PANEL SO IT IS MORE PORTABLE.

    render() {
        const {
            selectedClient,
            serviceModules,
            onReturnClick,
            channel,
            userData,
            newBookings,
            newChatMessages,
            newNutritionLogComments,
            newNutritionLogLikes,
            newNutritionLogReviews,
            newNutritionLogs,
            reduxLocation,
            provider,
            service,
            company,
            isDuringVideoSession = false,
        } = this.props; //clientIndex,
        const { viewIndex } = this.state;

        const serviceId =
            (this.props.selectedService && this.props.selectedService._id) ||
            (service && service._id);
        const notifications =
            this.props.unreadContentCount &&
            this.props.unreadContentCount[serviceId];

        const isProvider = userData && !!userData.provider;
        const isClient = userData && !userData.provider;

        // NOTIFICATIONS COUNTS
        const { newBookingCount } = !!notifications && notifications;
        const { newChatMessageCount } = !!notifications && notifications;
        const { newNutritionLogCount } = !!notifications && notifications;
        const { newNutritionLogCommentCount } =
            !!notifications && notifications;
        const { newNutritionLogReviewCount } = !!notifications && notifications;
        const { newNutritionLogLikeCount } = !!notifications && notifications;
        const { newExpertContentCount } = !!notifications && notifications;

        // BOOLEANS FOR IF THERE ARE NOTIFICATIONS
        const isNewBookings = !!newBookingCount && newBookingCount > 0;
        const isNewChatMessages =
            !!newChatMessageCount && newChatMessageCount > 0;
        const isNewNutritionLogs =
            !!newNutritionLogCount && newNutritionLogCount > 0;
        const isNewNutritionLogComments =
            !!newNutritionLogCommentCount && newNutritionLogCommentCount > 0;
        const isNewNutritionLogReviews =
            !!newNutritionLogReviewCount && newNutritionLogReviewCount > 0;
        const isNewNutritionLogLikes =
            !!newNutritionLogLikeCount && newNutritionLogLikeCount > 0;
        const isNewExpertContent =
            !!newExpertContentCount && newExpertContentCount > 0;

        // console.log('LIKEREVIEW AND COMMENT COUNTS COMBINED:', (newNutritionLogCommentCount) + (newNutritionLogReviewCount) + (newNutritionLogLikeCount))
        // console.log('LIKE COUNTS:', (newNutritionLogLikeCount))
        // console.log('REVIEW COUNTS:', ((newNutritionLogReviewCount)));
        // console.log('COMMENT COUNTS:', (newNutritionLogCommentCount));
        // console.log('IS THE LIKE DEFINED', notifications);
        // console.log('IP-props', this.props);
        // console.log('IP-state', this.state);

        return (
            <InteractionPanelOuterContainerSC
                id={'InteractionPanelOuterContainer'}
                maxWidth={constants.layout.breakpoint.break1}
                style={this.props.style}
            >
                {!!provider &&
                    !!service &&
                    !!company &&
                    !!serviceModules &&
                    !!userData && (
                        <ContextualBarSC>
                            {onReturnClick && !this.props.shouldHideBookingTab && (
                                <TextButton
                                    onClick={onReturnClick}
                                    style={{ width: 48 }}
                                >
                                    <ArrowBack />
                                </TextButton>
                            )}
                            <ListItem
                                key={service._id}
                                leftAvatar={this.getAvatar(
                                    userData,
                                    service,
                                    provider,
                                )}
                                primaryText={this.getPrimaryText(
                                    userData,
                                    service,
                                    selectedClient,
                                )}
                                secondaryText={this.getSecondaryText(
                                    userData,
                                    service,
                                    provider,
                                )}
                                hoverColor="none"
                                disableTouchRipple
                                disabled={true}
                                style={{
                                    maxWidth: '100%',
                                    textOverflow: 'ellipsis',
                                    width: 200,
                                }}
                            />
                        </ContextualBarSC>
                    )}
                <InteractionWindowSC>
                    {provider &&
                        service &&
                        company &&
                        serviceModules &&
                        channel && (
                            <StyledSwipeableViews
                                index={this.state.viewIndex}
                                onChangeIndex={this.handleChangeViewIndex}
                            >
                                {this.state.viewIndex === 0 &&
                                    !this.props.shouldHideBookingTab && (
                                        <InteractionModulesSC>
                                            {this.getBookingModule(
                                                userData,
                                                provider,
                                                service,
                                                reduxLocation,
                                            )}
                                        </InteractionModulesSC>
                                    )}
                                {this.state.viewIndex === 1 && (
                                    <InteractionModulesSC>
                                        <Chat
                                            offsetFix
                                            cynoMode={null}
                                            type="message"
                                            service={service}
                                            client={userData}
                                            channel={this.props.channel}
                                            provider={service.provider}
                                            isModulePartOfService={this.handleIsModulePartOfService(
                                                'chat',
                                                isDuringVideoSession,
                                                service.modules,
                                                this.props.serviceModules,
                                            )}
                                        />
                                    </InteractionModulesSC>
                                )}
                                {viewIndex === 2 && service && userData && (
                                    <InteractionModulesSC>
                                        <ScreenDimensionProvider
                                            render={(width, height) => (
                                                <PhotoLog
                                                    type="message"
                                                    service={service}
                                                    client={userData}
                                                    channel={channel}
                                                    provider={service.provider}
                                                    width={width}
                                                    height={height}
                                                    isModulePartOfService={this.handleIsModulePartOfService(
                                                        'photoLog',
                                                        isDuringVideoSession,
                                                        service.modules,
                                                        this.props
                                                            .serviceModules,
                                                    )}
                                                />
                                            )}
                                        />
                                    </InteractionModulesSC>
                                )}
                                {this.state.viewIndex === 3 && (
                                    <InteractionModulesSC>
                                        <VideoDocuments
                                            type="videoDocument"
                                            service={service}
                                            user={userData}
                                            provider={service.provider}
                                        />
                                    </InteractionModulesSC>
                                )}
                            </StyledSwipeableViews>
                        )}
                </InteractionWindowSC>

                <Tabs
                    onChange={this.handleChangeViewIndex}
                    value={this.state.viewIndex}
                    tabItemContainerStyle={styles.tabComponentStyles(
                        this.state.tabsHeight,
                    )}
                    id="tabsComponent"
                    inkBarStyle={styles.activeTabUnderlineStyles}
                >
                    {!this.props.shouldHideBookingTab && (
                        <Tab
                            icon={
                                <React.Fragment>
                                    <div
                                        style={{
                                            display:
                                                isNewBookings && isProvider
                                                    ? 'block'
                                                    : 'none',
                                        }}
                                    >
                                        <Badge
                                            badgeContent={newBookingCount}
                                            secondary={true}
                                            badgeStyle={{
                                                top: -12,
                                                right: -12,
                                            }}
                                            style={{ padding: 0 }}
                                        >
                                            <VideoCam
                                                style={this.getIconColor(0)}
                                            />
                                        </Badge>
                                    </div>
                                    <div
                                        style={{
                                            display:
                                                isNewBookings && isProvider
                                                    ? 'none'
                                                    : 'block',
                                        }}
                                    >
                                        <VideoCam
                                            style={this.getIconColor(0)}
                                        />
                                    </div>
                                </React.Fragment>
                            }
                            label="Bookings"
                            value={0}
                            style={{ color: 'gray', fontSize: 10 }}
                        />
                    )}

                    <Tab
                        icon={
                            <React.Fragment>
                                <div
                                    style={{
                                        display: isNewChatMessages
                                            ? 'block'
                                            : 'none',
                                    }}
                                >
                                    <Badge
                                        badgeContent={newChatMessageCount}
                                        secondary={true}
                                        badgeStyle={{ top: -12, right: -12 }}
                                        style={{ padding: 0 }}
                                    >
                                        <Message style={this.getIconColor(1)} />
                                    </Badge>
                                </div>
                                <div
                                    style={{
                                        display: isNewChatMessages
                                            ? 'none'
                                            : 'block',
                                    }}
                                >
                                    <Message style={this.getIconColor(1)} />
                                </div>
                            </React.Fragment>
                        }
                        label="Chat"
                        value={1}
                        style={{ color: 'gray', fontSize: 10 }}
                    />

                    <Tab
                        icon={
                            <React.Fragment>
                                <div
                                    style={{
                                        display:
                                            (isClient &&
                                                (isNewNutritionLogComments ||
                                                    isNewNutritionLogReviews ||
                                                    isNewNutritionLogLikes)) ||
                                            (isProvider && isNewNutritionLogs)
                                                ? 'block'
                                                : 'none',
                                    }}
                                >
                                    <Badge
                                        badgeContent={
                                            isClient
                                                ? newNutritionLogCommentCount +
                                                  newNutritionLogReviewCount +
                                                  newNutritionLogLikeCount
                                                : newNutritionLogCount
                                        }
                                        secondary={true}
                                        badgeStyle={{ top: -12, right: -12 }}
                                        style={{ padding: 0 }}
                                    >
                                        <PhotoCamera
                                            style={this.getIconColor(2)}
                                        />
                                    </Badge>
                                </div>
                                <div
                                    style={{
                                        display:
                                            (isClient &&
                                                (isNewNutritionLogComments ||
                                                    isNewNutritionLogReviews ||
                                                    isNewNutritionLogLikes)) ||
                                            (isProvider && isNewNutritionLogs)
                                                ? 'none'
                                                : 'block',
                                    }}
                                >
                                    <PhotoCamera style={this.getIconColor(2)} />
                                </div>
                            </React.Fragment>
                        }
                        label="Photo Log"
                        value={2}
                        style={{ color: 'gray', fontSize: 10 }}
                    />

                    <Tab
                        icon={
                            <React.Fragment>
                                <div
                                    style={{
                                        display:
                                            isClient && isNewExpertContent
                                                ? 'block'
                                                : 'none',
                                    }}
                                >
                                    <Badge
                                        badgeContent={newExpertContentCount}
                                        secondary={true}
                                        badgeStyle={{ top: -12, right: -12 }}
                                        style={{ padding: 0 }}
                                    >
                                        <Archive style={this.getIconColor(3)} />
                                    </Badge>
                                </div>
                                <div
                                    style={{
                                        display:
                                            isNewExpertContent && isClient
                                                ? 'none'
                                                : 'block',
                                    }}
                                >
                                    <Archive style={this.getIconColor(3)} />
                                </div>
                            </React.Fragment>
                        }
                        label="Documents"
                        value={3}
                        style={{ color: 'gray', fontSize: 10 }}
                    />
                </Tabs>
            </InteractionPanelOuterContainerSC>
        );
    }
}

const mapStateToProps = ({
    provider,
    service,
    company,
    auth,
    client,
    router,
    chat,
    notification,
}) => {
    // console.log('NOTIFICATIONS @ INT PANEL', notification.unreadCount);
    // console.log('', notification.notifications.nutritionLogLikes);

    return {
        reduxLocation: router.location,
        userData: client.clientData,
        userId: auth.authData ? auth.authData.id : null,
        providers: provider.providers,
        services: service.services,
        serviceCategories: service.categories,
        serviceModules: service.modules,
        companies: company.providerCompanies,
        selectedClient: provider.selectedClient,
        channel: chat.messageThread,
        // selectedService: service.selectedService,
        // NOTIFICATION PROPS
        newChatMessages: notification.notifications.chatMessages,
        newNutritionLogs: notification.notifications.nutritionLogs,
        newBookings: notification.notifications.bookings,
        newNutritionLogLikes: notification.notifications.nutritionLogLikes,
        newNutritionLogReviews: notification.notifications.nutritionLogReviews,
        newNutritionLogComments:
            notification.notifications.nutritionLogComments,
        newExpertContent: notification.notifications.expertContent,

        unreadContentCount:
            notification.unreadCount && notification.unreadCount,
    };
};

export default connect(
    mapStateToProps,
    actions,
)(InteractionPanel);

const styles = {
    activeTabUnderlineStyles: { backgroundColor: '#fecd08' },
    tabComponentStyles: tabsHeight => ({
        backgroundColor: 'white',
        borderTop: '1px gray solid',
        padding: 0,
        height: tabsHeight,
        overflow: 'hidden',
        height: '100%',
    }),
    tabsContainerStyles: state => ({
        position: 'relative',
        bottom: -9,
        height: '100%',
    }),
};



// WEBPACK FOOTER //
// ./src/js/components/InteractionComponents/InteractionPanel.jsx